/* eslint-disable react-hooks/exhaustive-deps */
import {lazy, Suspense, useCallback, useState} from 'react'

import PropTypes from 'prop-types'

import {useMountedState} from '@s-ui/react-hooks'

import ThirdPartyServicesContent from './third-party-services-content.js'

const LazyModalComponent = lazy(() => import(/* webpackChunkName: "LazyModalBasic" */ '@adv-mt/mt-modal-basic'))

const TEST_ID_CARD = 'third-party-services-card-container'

const BUTTON_TYPES = {
  button: 'button',
  link: 'link'
}

const NO_OP = () => {}

const CardThirdPartyServices = ({
  buttonIcon = null,
  children,
  modalCallback = null,
  onClickLink = NO_OP,
  thirdPartyInfo = {}
}) => {
  const getMountedState = useMountedState()
  const isMounted = getMountedState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const buttonTypeIsNotDefined = !thirdPartyInfo.buttonType
  const buttonTypeIsButton = thirdPartyInfo.buttonType === BUTTON_TYPES.button
  const isButton = buttonTypeIsNotDefined || buttonTypeIsButton

  const handleOpenModal = () => {
    setIsModalOpen(true)
    modalCallback && modalCallback({isOpen: true})
  }
  const handleCloseModal = () => {
    setIsModalOpen(false)
    modalCallback && modalCallback({isOpen: false})
  }

  const handleClick = () => (isButton ? handleOpenModal() : onClickLink())

  const cardContent = useCallback(
    () => (
      <ThirdPartyServicesContent
        buttonIcon={buttonIcon}
        handleButtonClick={handleClick}
        isButton={isButton}
        thirdPartyInfo={thirdPartyInfo}
      />
    ),
    [buttonIcon, thirdPartyInfo]
  )

  return (
    <div className="mt-CardThirdPartyServices" data-testid={TEST_ID_CARD}>
      {cardContent()}
      {isMounted && isModalOpen && (
        <Suspense fallback={<></>}>
          <LazyModalComponent
            isInsetBody={false}
            isInsetScrollArea
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            title={thirdPartyInfo.modalTitle}
          >
            {children}
          </LazyModalComponent>
        </Suspense>
      )}
    </div>
  )
}

CardThirdPartyServices.displayName = 'CardThirdPartyServices'
CardThirdPartyServices.propTypes = {
  buttonIcon: PropTypes.node,
  children: PropTypes.node,
  modalCallback: PropTypes.func,
  onClickLink: PropTypes.func,
  thirdPartyInfo: PropTypes.shape({
    bottomText: PropTypes.string,
    buttonText: PropTypes.string,
    buttonType: PropTypes.oneOf(BUTTON_TYPES),
    image: PropTypes.string,
    imageText: PropTypes.string,
    modalTitle: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    titleImage: PropTypes.string
  })
}

export {BUTTON_TYPES as buttonTypes}

export default CardThirdPartyServices
